import React, { useEffect } from 'react';
import { Grid, Button, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { PageContainer, Icons } from 'components';
import SubsetServices from '../../services/SubsetServices';
import { useStyles } from './style';
import { useQuery } from 'hooks';
import useCustomHook from '../../hooks';
import { constBreadCrumbsTitle } from 'utility';
export default function BranchDetail() {
  const navigate = useNavigate();
  const params = useParams();
  const classes = useStyles();

  const { loading, setLoading, formData, setFormData } = useCustomHook();
  const query = useQuery();
  useEffect(() => {
    setLoading(true);

    SubsetServices.getBranch({ businessId: params.id, offset: 0, size: 1 })
      .then((res) => {
        setFormData(res.result[0]);
        setLoading(false);
      })
      .catch(() => {});
  }, []);

  const getKeyBreadCrumbsWithUrl = () => {
    const imprest = query?.get('Imprest');
    return imprest ? constBreadCrumbsTitle.IMPREST_DETAILS : constBreadCrumbsTitle.BRANCH_DETAILS;
  };
  return (
    <PageContainer
      title={'جزئیات'}
      breadcrumbs={getKeyBreadCrumbsWithUrl()}
      className={classes.root}
      loading={loading}
      meta={
        <Button
          color="primary"
          variant="outlined"
          endIcon={<Icons icon="CaretLeft" color="#2b3990" size="25" />}
          onClick={() => navigate(`${query.get('Imprest') ? '/Imprest' : '/Branch'}`)}
        >
          {query.get('Imprest') ? 'بازگشت به لیست تنخواه گردان' : 'بازگشت به لیست شعبه ها'}
        </Button>
      }
    >
      <Grid container className={classes.info} direction="row" alignItems="center" item>
        {!loading && formData && (
          <>
            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>شناسه شعبه</Typography>
              <Typography className={classes.detailValue}>{formData.id}</Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>نام شعبه</Typography>
              <Typography className={classes.detailValue}>{formData.name}</Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>نام کاربری</Typography>
              <Typography className={classes.detailValue}>{formData.username}</Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>نام و نام‌خانوادگی نماینده</Typography>
              <Typography className={classes.detailValue}>
                {`${formData?.agent?.firstName ? formData?.agent?.firstName : '-'} ${
                  formData?.agent?.lastName ? formData?.agent?.lastName : '-'
                }`}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>شماره موبایل نماینده</Typography>
              <Typography className={classes.detailValue}>
                {formData?.agent?.cellphoneNumber}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>ایمیل</Typography>
              <Typography className={classes.detailValue}>{formData.email}</Typography>
            </Grid>

            <Grid item xs={12} className={classes.detail}>
              <Typography className={classes.detailTitle}>آدرس</Typography>
              <Typography className={classes.detailValue}>
                {`${formData.country ? formData.country + ' - ' : ''} 
                ${formData.state ? formData.state + ' - ' : ''}
                ${formData.city ? formData.city + ' - ' : ''} 
                ${formData.address ? formData.address : ''}`}
              </Typography>
            </Grid>

            <Grid item xs={12} className={classes.detail}>
              <Typography className={classes.detailTitle}>توضیحات</Typography>
              <Typography className={classes.detailValue}>{formData.description}</Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>شماره شبا</Typography>
              <Typography className={classes.detailValue}>
                {formData.sheba ? `IR${formData.sheba}` : '-'}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>شماره تلفن</Typography>
              <Typography className={classes.detailValue}>{formData.phone}</Typography>
            </Grid>

            <Grid item xs={12} className={classes.detail}>
              <Typography className={classes.detailTitle}>حساب تفصیلی کسب و کار</Typography>
              <Typography className={classes.detailValue}>
                {Array.isArray(formData.guilds) &&
                  formData.guilds.map((guild) => (
                    <span className={classes.guildTag}>{`${guild.id}.${guild.name}`}</span>
                  ))}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>امتیاز شعبه</Typography>
              <Typography className={classes.detailValue}>
                {`${formData?.rate?.rate} از ${formData?.rate?.rateCount}`}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>تعداد محصولات</Typography>
              <Typography className={classes.detailValue}>{formData.numOfProducts}</Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>شناسه کاربری</Typography>
              <Typography className={classes.detailValue}>{formData.userId}</Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>شناسه sso</Typography>
              <Typography className={classes.detailValue}>{formData.ssoId}</Typography>
            </Grid>
          </>
        )}
      </Grid>
    </PageContainer>
  );
}
